import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-base-send-sms',
  templateUrl: './base-send-sms.component.html',
  styleUrl: './base-send-sms.component.scss'
})
export class BaseSendSMSComponent {
  editId;
  systemMenuId;

  // constructor
  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.editId = data.id;
    this.systemMenuId = data.systemMenuId;
  }

  ngOnInit(): void {
  }

  send() {

  }

}
